module.exports = __webpack_public_path__ + "static/media/ttd-ketua-bem.d7075935.jpeg";